/**
 * Redirects to home when the Goody gift shop stage is not Active (PBI #1554).
 * Renders nothing until /api/features resolves so the browse page never flashes.
 */
import { Navigate } from 'react-router-dom';
import { useFeatures } from '../../contexts/FeaturesContext';
import { PUBLIC_ROUTES } from '../../constants/routes';
import type { ReactNode } from 'react';

export interface GiftShopRouteProps {
  children: ReactNode;
}

export function GiftShopRoute({ children }: GiftShopRouteProps) {
  const { isGiftCatalogEnabled, featuresResolved } = useFeatures();

  if (!featuresResolved) {
    return null;
  }

  if (!isGiftCatalogEnabled) {
    return <Navigate to={PUBLIC_ROUTES.home} replace />;
  }

  return children;
}
